import React, { Dispatch, SetStateAction, useState } from 'react'

type ContextProps<T> = [T, Dispatch<SetStateAction<T>>]

type CreateContextResult<T> = {
  Provider: React.FC<T>
  useContext: () => ContextProps<T>
}

const ArrowFunction = () => {
  return
}

export const useContext = <T, >(
  defaultValue: T,
): { Provider: React.Provider<ContextProps<T>>; useContext: () => ContextProps<T> } => {
  const Context: React.Context<ContextProps<T>> = React.createContext<ContextProps<T>>([
    defaultValue,
    ArrowFunction,
  ])
  return { Provider: Context.Provider, useContext: () => React.useContext(Context) }
}

export const createContext = <T, >(defaultValue: T): CreateContextResult<T> => {
  const Context = useContext(defaultValue)

  const Provider: React.FC = ({ children }) => {
    const state = useState<T>(defaultValue)

    return <Context.Provider value={state}>{children}</Context.Provider>
  }

  return { Provider, useContext: Context.useContext }
}
